<script setup lang="ts">
import useModel from './../model/model'
import { AdminServicesMQTTForm, AdminServicesSwitchFrom } from '@/features/Cabinet'
import AdminServicesDiagnostics from './AdminServicesDiagnostics.vue'

const model = useModel()

model.loadData()
</script>

<template>
  <VTabs class="mt-n4 mb-6" v-model="model.serviceTab">
    <VTab value="mqtt">{{ $t('itf.mqtt') }}</VTab>
    <VTab value="diagnostics">{{ $t('itf.diagnostics') }}</VTab>
    <VTab value="switching">{{ $t('itf.switching') }}</VTab>
  </VTabs>

  <template v-if="model.cabinet">
    <AdminServicesMQTTForm
      v-if="model.serviceTab === 'mqtt'"
      :serial="model.cabinet.serial_number"
      :brokers="model.brokers"
    />

    <AdminServicesDiagnostics
      v-if="model.serviceTab === 'diagnostics'"
      :status="model.cabinet.pe_status"
    />

    <AdminServicesSwitchFrom v-if="model.serviceTab === 'switching'" :cabinet="model.cabinet" />
  </template>
</template>
